import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  rowsContainer: {
    minWidth: 'min-content',
    width: '100%',
    overflow: 'hidden',
    justifyContent: 'space-between',
    ':not(:last-child) > div': {
      marginBottom: anatomy['size-4'],
    },
  },
  row: {
    fontSize: typography['fontSizeCaption-2'],
    lineHeight: typography['lineHeightCaption-2'],
    display: 'grid',
    background: colors.primaryBackground,
    borderRadius: anatomy.borderRadiusS,
    alignItems: 'center',
    color: colors.primaryText,
    ':not(:last-child)': {
      marginBottom: anatomy['size-4'],
    },
    width: '100%',
  },
  rowItemBase: {
    position: 'relative',
    display: 'flex',
    width: '100%',
    overflow: 'hidden',
    height: '100%',
  },
  rowItem: {
    position: 'relative',
    display: 'flex',
    width: '100%',
    padding: `${anatomy['size-16']} ${anatomy['size-12']}`,
    overflow: 'hidden',
    height: '100%',
  },
  rowFixed: {
    background: colors.primaryBackground,
    position: 'sticky !important',
    zIndex: 1,
    left: 0,
  },
});
